import { createSlice } from "@reduxjs/toolkit";
import { AibleClientFactory } from "client/aible/factory";
const RATING_CLIENT = AibleClientFactory.getInstance().getRatingClient();
const initialState = {
    PROJECT_ASSUMPTION: {},
    PROJECT_SCENARIO: {},
    PROJECT_SEGMENT_ASSUMPTION: {},
    PROJECT_TASK: {},
    TRAINING_DATA: {},
    COMMENT: {},
    REPORT: {},
    REPORT_CHART: {},
    LANGUAGE_MODEL_ARTIFACT: {},
    CHAT_TONE: {},
    CONTENT_GENERATION_COLLECTION: {},
    CONTENT_GENERATION_EXECUTION: {},
    CONTENT_GENERATION_RESULT: {}
};
function updateStateWithRating(state, rating) {
    return {
        ...state,
        [rating.entity_type]: {
            ...(state[rating.entity_type] ?? {}),
            [rating.entity_id]: {
                ...(state[rating.entity_type]?.[rating.entity_id] ?? {}),
                [rating.id]: {
                    ...(state[rating.entity_type]?.[rating.entity_id]?.[rating.id] ?? {}),
                    ...rating
                }
            }
        }
    };
}
const ratingSlice = createSlice({
    name: "rating",
    initialState: initialState,
    reducers: {
        updateRating(state, { payload }) {
            return updateStateWithRating(state, payload);
        },
        updateRatings(state, { payload }) {
            return payload.reduce(updateStateWithRating, state);
        }
    }
});
export const { updateRating, updateRatings } = ratingSlice.actions;
export default ratingSlice.reducer;
export function getRatingsById(state, rateableType, rateableId) {
    return state.rating[rateableType][rateableId] ?? {};
}
export function fetchRatings(rateableType, rateable) {
    return (dispatch, getState) => {
        return RATING_CLIENT.getRatings(rateableType, rateable.id).then((ratings) => {
            dispatch(ratingSlice.actions.updateRatings(ratings));
            return getRatingsById(getState(), rateableType, rateable.id);
        });
    };
}
export function fetchRating(ratingId) {
    return (dispatch) => {
        return RATING_CLIENT.getRating(ratingId).then((rating) => {
            dispatch(updateRating(rating));
            return rating;
        });
    };
}
export function updateRatingAndSave(ratingId, update) {
    return (dispatch) => {
        return RATING_CLIENT.updateRating(ratingId, update).then((rating) => {
            dispatch(updateRating(rating));
            return rating;
        });
    };
}
export function likeRatable(rateableType, rateableId) {
    return addRating(rateableType, rateableId, "LIKE");
}
export function dislikeRatable(rateableType, rateableId) {
    return addRating(rateableType, rateableId, "DISLIKE");
}
export function addRating(rateableType, rateableId, feedback) {
    return (dispatch) => {
        return RATING_CLIENT.addRating(rateableType, rateableId, { feedback }).then((rating) => {
            dispatch(updateRating(rating));
            return rating;
        });
    };
}
export function deleteRating(ratingId) {
    return (dispatch) => {
        return RATING_CLIENT.deleteRating(ratingId).then((rating) => {
            dispatch(updateRating(rating));
            return rating;
        });
    };
}
